import WineOff from "./WineOff";

export * from "./Amphora";
export * from "./Apple";
export * from "./Banana";
export * from "./Bean";
export * from "./BeanOff";
export * from "./Beer";
export * from "./BeerOff";
export * from "./CakeSlice";
export * from "./Candy";
export * from "./CandyCane";
export * from "./CandyOff";
export * from "./Carrot";
export * from "./Cherry";
export * from "./Citrus";
export * from "./Coffee";
export * from "./CokingPot";
export * from "./Croissant";
export * from "./CupSoda";
export * from "./Dessert";
export * from "./DnaOff";
export * from "./Donut";
export * from "./DrumStick";
export * from "./EggOff";
export * from "./EggFried";
export * from "./GlassWater";
export * from "./Grape";
export * from "./Ham";
export * from "./HandPlater";
export * from "./Hop";
export * from "./HopOff";
export * from "./IceCreamBowl";
export * from "./IceCreamCone";
export * from "./Lollipop";
export * from "./Martini";
export * from "./Microwave";
export * from "./Milk";
export * from "./Nut";
export * from "./NutOff";
export * from "./Pizza";
export * from "./Popcorn";
export * from "./Popsicle";
export * from "./Refrigerator";
export * from "./SandWich";
export * from "./ShefHat";
export * from "./Soup";
export * from "./Tractor";
export * from "./Utensils";
export * from "./UtlensilsCrossed";
export * from "./Vegan";
export * from "./Wheat";
export * from "./Wheatoff";
export * from "./Wine";
export * from "./WineOff";

export const Food = {
  WineOff,
};
